import React from 'react';
import PropTypes from 'prop-types';

const ReverseGeocoding = ({ fill, ...props }) => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 28 28"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M21.0003 10.8882C21.0036 12.3882 20.5218 13.849 19.6268 15.0526L14.0003 22.5555L8.37388 15.0526C7.71511 14.1626 7.27689 13.1289 7.0952 12.0365C6.91351 10.9442 6.99354 9.82431 7.32873 8.7689C7.66391 7.71349 8.24467 6.75266 9.02332 5.96532C9.80197 5.17799 10.7563 4.58661 11.8079 4.23978C12.8595 3.89295 13.9783 3.80054 15.0726 3.97017C16.1668 4.13979 17.2052 4.5666 18.1024 5.21553C18.9997 5.86446 19.7302 6.71701 20.234 7.70313C20.7377 8.68926 21.0004 9.78084 21.0003 10.8882ZM23.3337 10.8882C23.3337 12.9728 22.6508 14.8955 21.4981 16.448L15.4579 24.5L14.0003 26.4446L12.5412 24.5L6.50255 16.448C5.62317 15.2618 5.0378 13.8837 4.79453 12.4272C4.55125 10.9707 4.65703 9.4772 5.10315 8.06951C5.54928 6.66181 6.32303 5.38005 7.36082 4.32956C8.39862 3.27907 9.67084 2.48982 11.073 2.02665C12.4751 1.56349 13.9671 1.43963 15.4264 1.66526C16.8857 1.89089 18.2706 2.45956 19.4674 3.32455C20.6642 4.18954 21.6387 5.32617 22.3108 6.64104C22.9829 7.9559 23.3335 9.41149 23.3337 10.8882ZM14.0003 13.9995C14.8254 13.9995 15.6168 13.6717 16.2002 13.0882C16.7837 12.5047 17.1114 11.7134 17.1114 10.8882C17.1114 10.063 16.7837 9.27167 16.2002 8.6882C15.6168 8.10472 14.8254 7.77693 14.0003 7.77693C13.1752 7.77693 12.3839 8.10472 11.8004 8.6882C11.217 9.27167 10.8892 10.063 10.8892 10.8882C10.8892 11.7134 11.217 12.5047 11.8004 13.0882C12.3839 13.6717 13.1752 13.9995 14.0003 13.9995Z"
      fill={fill || '#6B6C7B'}
    />
  </svg>
);

ReverseGeocoding.propTypes = {
  fill: PropTypes.string,
};

export default ReverseGeocoding;
